import React, { useRef, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { TextField } from '~/components/Form/v2';
import { SENHA_MAXIMO } from '~/constants/default';
import { COMPLEXIDADE_SENHA } from '~/constants/modules';
import { t, can } from '~/helpers';
import { validation, validationErrors } from '~/helpers/yupValidations';
import api from '~/services/api';

import { Wrapper } from './styles';

export default function ChangePassword({ sending, close, toggleDisabled }) {
  const user = useSelector((state) => state.user.profile);
  const formRef = useRef(null);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        await toggleDisabled(true);

        const schema = Yup.object().shape({
          senhaatual: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(
              SENHA_MAXIMO,
              t('s.geral.validacao.tamanhomaximo').replace('%s', SENHA_MAXIMO)
            ),
          senhanova: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(
              SENHA_MAXIMO,
              t('s.geral.validacao.tamanhomaximo').replace('%s', SENHA_MAXIMO)
            ),
          senhanovaconfirmada: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .oneOf(
              [Yup.ref('senhanova'), null],
              t('labelsistema.erro_senha_nao_confere')
            )
            .max(
              SENHA_MAXIMO,
              t('s.geral.validacao.tamanhomaximo').replace('%s', SENHA_MAXIMO)
            ),
        });

        await validation(schema, data);

        if (can(COMPLEXIDADE_SENHA)) {
          await api.post('logins/changepassword', {
            subdominio: window.location.hostname.split('.')[0],
            codigousuario: user.username,
            senhaatual: data.senhaatual,
            senhanova: data.senhanova,
            senhanovaconfirmacao: data.senhanovaconfirmada,
          });
          toast.success(t('Senha alterada com sucesso.'));
        } else {
          await api.put('alteracoessenhasusuarios', data);
          toast.success(t('Senha alterada com sucesso.'));
        }

        await close();
      } catch (err) {
        validationErrors(err, formRef);
      } finally {
        toggleDisabled(false);
      }
    },
    [user]
  );

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      <Wrapper>
        <TextField
          name="senhaatual"
          type="password"
          label={t('s.geral.senhaatual')}
        />

        <TextField
          name="senhanova"
          type="password"
          label={t('s.geral.senhanova')}
        />

        <TextField
          name="senhanovaconfirmada"
          type="password"
          label={t('s.geral.senhanovaconfirmada')}
        />
      </Wrapper>
    </Form>
  );
}

ChangePassword.propTypes = {
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  toggleDisabled: PropTypes.func.isRequired,
};
